<template>
	<view class="box">
		<view class="item">
			<view class="item-tx">
				<image src="/static/logo.png" mode="widthFix"></image>
			</view>
			<view class="item-info">
				<view class="item-info-a">
					<text>刘永慧</text>
					<text>P6｜销售培训师</text>
				</view>
				<view class="item-info-b">
					<view class="item-info-b-row">市场类</view>
					<view class="item-info-b-row">获客类</view>
					<view class="item-info-b-row">培训类</view>
				</view>
				<view class="item-info-c">
					<view class="item-info-c-item">
						<view class="item-info-c-item-label">从业年限：</view>
						<view class="item-info-c-item-val">10年</view>
					</view>
					<view class="item-info-c-item">
						<view class="item-info-c-item-label">近半年服务商场数：</view>
						<view class="item-info-c-item-val">38个</view>
					</view>
				</view>
				<view class="item-info-d">
					从事设计商业化已有多年，擅长各种风格，服务大客户超过50户…<text>更多</text>
				</view>
				<view class="item-info-price">
					<text>标准收费</text>
					<text>2900</text>
				</view>
			</view>
		</view>
		<view class="card">
			<view class="card-title">
				<view class="card-title-xian"></view>
				<text>擅长领域</text>
			</view>
			<view class="card-list">
				<view class="card-list-item">
					<view class="card-list-item-title">运营操盘：</view>
					<view class="card-list-item-text">城市运营规划，导入门店日常标准化管理、标准数据、Z7动作执行等；</view>
				</view>
				<view class="card-list-item">
					<view class="card-list-item-title">培训提升：</view>
					<view class="card-list-item-text">理论实践培训以及员工综合能力构建；</view>
				</view>
				<view class="card-list-item">
					<view class="card-list-item-title">主动营销：</view>
					<view class="card-list-item-text">近40余场次大型主题营销爆破活动落地：开业、周年庆、新品发布会等；擅长酒店、微联盟组建、商场中庭、店面爆破等；</view>
				</view>
				<view class="card-list-item">
					<view class="card-list-item-title">大单成交：</view>
					<view class="card-list-item-text">客户全流程服务以及大客户跟踪和成交洽谈；</view>
				</view>
			</view>
		</view>
		<view class="card">
			<view class="card-title">
				<view class="card-title-xian"></view>
				<text>优秀项目案例 (40)</text>
			</view>
			<view class="work">
				<view class="work-item" v-for="(item, index) in 5" :key="index">
					<view class="left">
						<view class="left-title">云南-大理《三店同庆开业活动》</view>
						<view class="left-time">
							<image src="/static/ic_time@2x.png" mode="widthFix"></image>
							<text>2025-10-01 ~ 2025-10-15</text>
						</view>
						<view class="left-info">居然之家商场落地，合计定单150单，同比增长210%，收款280万</view>
					</view>
					<view class="right">
						<image src="/static/logo.png" mode="widthFix"></image>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style>
	page {
		background-color: #f7f7f7;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.item {
			width: 100%;
			background: #FFFFFF;
			border-radius: 8rpx;
			padding: 24rpx;
			box-sizing: border-box;
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
			margin-bottom: 20rpx;
			&:last-child {
				margin: 0 !important;
			}
			.item-tx {
				flex-shrink: 0;
				width: 128rpx;
				height: 168rpx;
				border-radius: 8rpx;
				overflow: hidden;
				margin-right: 20rpx;
				image {
					width: 100%;
				}
			}
			.item-info {
				flex: 1;
				display: flex;
				flex-direction: column;
				position: relative;
				.item-info-price {
					position: absolute;
					right: 0;
					top: 0;
					display: flex;
					align-items: flex-end;
					flex-direction: column;
					text {
						&:nth-child(1) {
							font-weight: 400;
							font-size: 22rpx;
							color: #FF7000;
						}
						&:nth-child(2) {
							font-weight: 600;
							font-size: 30rpx;
							color: #FF7000;
							&::after {
								content: "元/周";
								font-weight: 600;
								font-size: 20rpx;
								color: #FF7000;
							}
						}
					}
				}
				.item-info-a {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-weight: 600;
							font-size: 30rpx;
							color: #222222;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 24rpx;
							color: #777777;
							margin-left: 10rpx;
						}
					}
				}
				.item-info-b {
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					margin-top: 8rpx;
					.item-info-b-row {
						padding: 0 8rpx;
						box-sizing: border-box;
						height: 40rpx;
						line-height: 40rpx;
						border-radius: 8rpx;
						border: 1rpx solid #2E68C4;
						font-weight: 400;
						font-size: 22rpx;
						color: #2E68C4;
						margin-right: 8rpx;
						&:last-child {
							margin: 0;
						}
					}
				}
				.item-info-c {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 20rpx;
					.item-info-c-item {
						display: flex;
						align-items: center;
						.item-info-c-item-label {
							font-weight: 400;
							font-size: 24rpx;
							color: #777777;
						}
						.item-info-c-item-val {
							font-weight: 400;
							font-size: 24rpx;
							color: #333333;
						}
					}
				}
				.item-info-d {
					width: 100%;
					font-weight: 400;
					font-size: 24rpx;
					color: #333333;
					margin-top: 20rpx;
					text {
						color: #2E68C4;
					}
				}
			}
		}
		.card {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 20rpx;
			.card-title {
				display: flex;
				align-items: center;
				margin-bottom: 22rpx;
				.card-title-xian {
					width: 6rpx;
					height: 32rpx;
					background: #2E68C4;
					border-radius: 6rpx;
					margin-right: 12rpx;
				}
				text {
					font-weight: 600;
					font-size: 32rpx;
					color: #222222;
				}
			}
			.work {
				width: 100%;
				.work-item {
					width: 100%;
					padding: 30rpx 0;
					box-sizing: border-box;
					display: flex;
					align-items: flex-start;
					border-bottom: 1rpx solid #E5E5E5;
					.left {
						flex: 1;
						display: flex;
						flex-direction: column;
						.left-title {
							font-weight: 600;
							font-size: 30rpx;
							color: #333333;
						}
						.left-time {
							display: flex;
							align-items: center;
							margin: 20rpx 0;
							image {
								flex-shrink: 0;
								width: 26rpx;
								height: 26rpx;
								margin-right: 10rpx;
							}
							text {
								font-weight: 400;
								font-size: 26rpx;
								color: #666666;
							}
						}
						.left-info {
							font-weight: 400;
							font-size: 26rpx;
							color: #666666;
						}
					}
					.right {
						flex-shrink: 0;
						width: 200rpx;
						height: 150rpx;
						overflow: hidden;
						border-radius: 8rpx;
						margin-left: 20rpx;
						image {
							width: 100%;
						}
					}
				}
			}
			.card-list {
				width: 100%;
				.card-list-item {
					display: flex;
					flex-direction: column;
					margin-bottom: 20rpx;
					&:last-child {
						margin: 0 !important;
					}
					.card-list-item-title {
						font-weight: 500;
						font-size: 28rpx;
						color: #333333;
					}
					.card-list-item-text {
						font-weight: 500;
						font-size: 26rpx;
						color: #666666;
					}
				}
			}
		}
	}
</style>